import {Link} from "react-router-dom";
import {ForgetPasswordComponent} from "../components/connection/forget-password";
import {useTranslation} from "react-i18next";

function ForgetPassword() {
    const {t} = useTranslation();
    return (
        <div className="password-forget flex justify-center items-center h-screen">
            <div className="centered-element">
                <ForgetPasswordComponent/>
                <div className="text-center mt-4">
                    <Link to="/login" className="text-blue-500 hover:text-blue-700 font-bold text-xs">{t('Return connection')}</Link>
                </div>
            </div>
        </div>
    );
}

export default ForgetPassword;